var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_vm._l((_vm.items),function(item,index){return _c('router-link',{key:index,staticClass:"item",class:[{ active: item.link === _vm.$route.path }, { disable: item.disable }],attrs:{"to":item.link}},[_vm._v(" "+_vm._s(item.title)+" ")])}),_c('div',{staticClass:"left"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }